export default __webpack_public_path__ + "static/webRotator/svg/1f0cba54b9ea9b158f180559318596ec.svg";